import React, { Component } from 'react';
import { NavTab } from 'ui/components';

import './OrderNav.scss';

export default class OrderNav extends Component {
	render() {
		const getPartNumbers = ['GetPartNumbers'];
		const getOrderHistory = ['GetOrderHistory'];

		return (
			<ul className="nav nav-tabs">
				<NavTab
					api={getOrderHistory}
					route="/view-order-history"
					name="orderHistory.viewOrderHistoryTab"
				/>
				<NavTab
					api={getPartNumbers}
					route="/view-order-history/search-part-number"
					name="orderHistory.searchPartNumberTab"
				/>
			</ul>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/OrderNav/index.js